import { ReactNode } from "react";
import LayeredPanels from "../common/page/LayeredPanels";

export interface SearchSidebarProps {
  // Tab content
  filtersContent?: ReactNode;
  listContent?: ReactNode;
  detailsContent?: ReactNode;

  // Tab state
  activeTab?: 'filters' | 'list' | 'details';
  onTabChange?: (tab: 'filters' | 'list' | 'details') => void;
  stack?: ('filters' | 'list' | 'details')[];

  // Tab visibility
  showFiltersTab?: boolean;
  showListTab?: boolean;
  showDetailsTab?: boolean;
}

export default function SearchSidebar({
  filtersContent,
  listContent,
  detailsContent,
  activeTab = 'filters',
  stack,
  showFiltersTab = true,
  showListTab = true,
  showDetailsTab = true,
}: SearchSidebarProps) {

  // Count visible tabs to determine if we should show tab navigation
  const visibleTabs = [
    showFiltersTab && filtersContent,
    showListTab && listContent,
    showDetailsTab && detailsContent,
  ].filter(Boolean).length;

  // If only one tab is visible, don't show tab navigation
  const shouldShowTabs = visibleTabs > 1;

  if (!shouldShowTabs) {
    // Single tab - render content directly without tab navigation
    if (showFiltersTab && filtersContent) {
      return <div className="h-full">{filtersContent}</div>;
    }
    if (showListTab && listContent) {
      return <div className="h-full">{listContent}</div>;
    }
    if (showDetailsTab && detailsContent) {
      return <div className="h-full">{detailsContent}</div>;
    }
    return null;
  }

  return (
    <LayeredPanels
      stack={stack ?? [activeTab]}
      panels={[
        ...(showListTab && listContent ? [{ id: "list", content: listContent }] : []),
        ...(showDetailsTab && detailsContent ? [{ id: "details", content: detailsContent }] : []),
        ...(showFiltersTab && filtersContent ? [{ id: "filters", content: filtersContent }] : []),
      ]}
    />
  );
}
